export enum EmeraldDialogTypes {
  Error = 'Error', //Error: Red solid circle with letter "x"
  Info = 'Info', //Notification: Blue solid circle with letter "i"
  InfoDecision = 'InfoDecision', //DecisionTaking: Green solid circle with question mark
  Prohibit = 'Prohibit', //Prohibit: Red solid circle with white bar
  Warning = 'Warning', //Attention: Red empty triangle with exclaimation mark
  Status = 'Status', //Status: blue solid circle with an i
  Success = 'Success', //Success: green checkmark
  None = 'None', //None: An icon and bar is not desired
}
